<template>
    <div>
        <div class="row">
            <div class="col-md-12 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Achievement (YTD {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <table style="width: 100%;">
                        <tr>
                            <td class="text-center gradient-right-border cell-padding-1" style="vertical-align: top;min-width: 83px;">
                                <div class="td-header">Sales Area</div>
                                <div class="cell-value pt-1">ALL</div>
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">Realisasi Ytd</div>
                                <div :class="'cell-value pt-1 ' + (this.reportdata?.data?.achievement?.realisasi_ytd < this.reportdata?.data?.achievement?.target_ytd ? 'text-color-danger':'text-color-success')">{{ formatNum(this.reportdata?.data?.achievement?.realisasi_ytd) }}</div>
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">Target Ytd</div>
                                <div class="cell-value pt-1">{{ formatNum(this.reportdata?.data?.achievement?.target_ytd) }}</div>
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1" style="min-width: 120px;">
                                <div class="td-header text-secondary">Performance Ytd</div>
                                <div :class="'cell-value pt-1 ' + (this.reportdata?.data?.achievement?.realisasi_ytd < this.reportdata?.data?.achievement?.target_ytd ? 'text-color-danger':'text-color-success')">{{ formatNum(this.reportdata?.data?.achievement?.performance) }} %</div>
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">Target RKAP</div>
                                <div class="cell-value pt-1 text-color-primary">{{ formatNum(this.reportdata?.data?.achievement?.target_rkap) }}</div>
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">Sisa Target Ytd</div>
                                <div class="cell-value pt-1">{{ formatNum(this.reportdata?.data?.achievement?.left_over_target) }}</div>
                            </td>
                            <td class="text-left cell-padding-1" style="min-width: 110px;">
                                <div class="td-header text-secondary">Sisa Target Ytd (%)</div>
                                <div class="cell-value pt-1">{{ formatNum(this.reportdata?.data?.achievement?.left_over_target_percentage) }} %</div>
                            </td>
                        </tr>
                    </table>
                    <Loader v-if="loading.table"/>
                </div>
            </div>

            <div class="col-md-12" v-if="false">
                <div class="box-title-border-with-detail px-3 py-1" style="">Payment Method (YTD {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-3" style="overflow-x: auto;">
                    <table style="width: 100%;">
                        <tr>
                            <td class="text-center gradient-right-border cell-padding-1" style="vertical-align: top;min-width: 83px;">
                                <div class="td-header">Sales Area</div>
                                <div class="cell-value pt-1">ALL</div>
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">Cash (%)</div>
                                <div :class="'cell-value pt-1'">{{ formatNum(this.paymentmethoddata.data[0].cash_percentage) }} %</div>
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">Non Cash (%)</div>
                                <div :class="'cell-value pt-1'">{{ formatNum(this.paymentmethoddata.data[0].non_cash_percentage) }} %</div>
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">EDC (%)</div>
                                <div :class="'cell-value pt-1'">{{ formatNum(this.paymentmethoddata.data[0].non_cash_percentage_edc) }} %</div>
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1">
                                <div class="td-header text-secondary">Voucher (%)</div>
                                <div :class="'cell-value pt-1'">{{ formatNum(this.paymentmethoddata.data[0].non_cash_percentage_voucher) }} %</div>
                            </td>
                            <td class="text-center cell-padding-1">
                                <div class="td-header text-secondary">RFID (%)</div>
                                <div class="cell-value pt-1">{{ formatNum(this.paymentmethoddata.data[0].non_cash_percentage_rfid) }} %</div>
                            </td>
                        </tr>
                    </table>
                    <Loader v-if="loading.paymentmethod"/>
                </div>
            </div>
        </div>

		<div class="row" v-if="false">
            <div class="col-md-12 mb-4" v-if="false">
                <h5 class="text-center">Achievement (YTD {{ this.monthBefore }} {{ this.currentYear }})</h5>
                <ReportResultTable  :reportname="'Achievement'" :reportdata="rkaprealisasi" :loading="loading.achievement" :reporturl="''" :issuccess="loading.isSuccess" style="width:100%;"/> 	
            </div>
            <div class="col-md-12 mb-4" v-if="false">
                <h5 class="text-center">Payment Method (YTD {{ this.monthBefore }} {{ this.currentYear }})</h5>
                <ReportResultTable  :reportname="'PaymentMethod'" :reportdata="paymentmethoddata" :loading="loading.paymentmethod" :reporturl="''" :issuccess="loading.isSuccess" style="width:50%;margin:0 auto;"/> 	
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-md-12">
                <div class="box-title-border-with-detail px-3 py-1" style="">Lowest Growth By Month ({{ this.monthBefore2 }} vs {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-2 bg-color" style="overflow-x: auto;">
                    <table style="width: 100%;">
                        <tr style="border-bottom:5px solid transparent;">
                            <td class="text-center gradient-right-border cell-padding-1 text-secondary td-header">
                                No
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1 text-secondary td-header">
                                Branch Id
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1 text-secondary td-header">
                                Branch Name
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1 text-secondary td-header">
                                {{ growthbymonth.data ? getShortMonthName(growthbymonth.data[0].Bulan0) :'Before' }}
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1 text-secondary td-header">
                                {{ growthbymonth.data ? getShortMonthName(growthbymonth.data[0].Bulan) :'After' }}
                            </td>
                            <td class="text-center cell-padding-1 text-secondary td-header">
                                Sales Difference (%)
                            </td>
                        </tr>
                        <tr v-for="(item7, idx7) in growthbymonth.data" :key="idx7" style="border-bottom: 6px solid transparent;">
                            <td class="text-center" style="width:60px;">
                                <div class="cell-left">
                                    <div class="box-number" style="width:30px;height:30px;">{{ ++idx7 }}</div>
                                </div>
                            </td>
                            <td class="text-left gradient-right-border-white" style="vertical-align:middle;">
                                <div class="cell-center cell-value2">
                                    {{ item7.BranchId }}
                                </div>
                            </td>
                            <td class="text-left gradient-right-border-white cell-value2" style="vertical-align:middle;">
                                <div class="cell-center" style="margin-left:-1px;margin-right:-2px;">
                                    {{ item7.BranchName }}
                                </div>
                            </td>
                            <td class="text-right gradient-right-border-white cell-value2 text-danger" style="vertical-align:middle;">
                                <div class="cell-center">
                                    {{ formatNum(item7.Sales0) }}
                                </div>                               
                            </td>
                            <td class="text-right gradient-right-border-white cell-value2 text-danger" style="vertical-align:middle;">
                                <div class="cell-center">
                                    {{ formatNum(item7.Sales) }}
                                </div>                               
                            </td>
                            <td class="text-center cell-value2 text-danger" style="vertical-align:middle;">
                                <div class="cell-right">
                                    {{ formatNum(item7.SelisihPersentase) }} %
                                </div>                               
                            </td>
                        </tr>
                    </table>
                    <Loader v-if="loading.table"/>
                </div>
            </div>
        </div>

        <div class="row mt-4 mb-4">
            <div class="col-md-12">
                <div class="box-title-border-with-detail px-3 py-1" style="">Lowest Growth By Year ({{ this.monthBefore }} <b>{{ this.currentYear-1 }}</b> vs {{ this.monthBefore }} <b>{{ this.currentYear }}</b>)</div>
                <div class="box-border-with-title pt-3 pb-3 px-2 bg-color" style="overflow-x: auto;">
                    <table style="width: 100%;">
                        <tr style="border-bottom:5px solid transparent;">
                            <td class="text-center gradient-right-border cell-padding-1 text-secondary td-header">
                                No
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1 text-secondary td-header">
                                Branch Id
                            </td>
                            <td class="text-left gradient-right-border cell-padding-1 text-secondary td-header">
                                Branch Name
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1 text-secondary td-header">
                                {{ growthbyyear.data ? getShortMonthName(growthbyyear.data[0].Bulan0) + ' ' + growthbyyear.data[0].Tahun0 :'Before' }}
                            </td>
                            <td class="text-center gradient-right-border cell-padding-1 text-secondary td-header">
                                {{ growthbyyear.data ? getShortMonthName(growthbyyear.data[0].Bulan) + ' ' + growthbyyear.data[0].Tahun :'After' }}
                            </td>
                            <td class="text-center cell-padding-1 text-secondary td-header">
                                Sales Difference (%)
                            </td>
                        </tr>
                        <tr v-for="(item7, idx7) in growthbyyear.data" :key="idx7" style="border-bottom: 6px solid transparent;">
                            <td class="text-center" style="width:60px;">
                                <div class="cell-left">
                                    <div class="box-number" style="width:30px;height:30px;">{{ ++idx7 }}</div>
                                </div>
                            </td>
                            <td class="text-left gradient-right-border-white" style="vertical-align:middle;">
                                <div class="cell-center cell-value2">
                                    {{ item7.BranchId }}
                                </div>
                            </td>
                            <td class="text-left gradient-right-border-white cell-value2" style="vertical-align:middle;">
                                <div class="cell-center" style="margin-left:-1px;margin-right:-2px;">
                                    {{ item7.BranchName }}
                                </div>
                            </td>
                            <td class="text-right gradient-right-border-white cell-value2 text-danger" style="vertical-align:middle;">
                                <div class="cell-center" style="margin-left:-1px;margin-right:-2px;">
                                    {{ formatNum(item7.Sales0) }}
                                </div>
                            </td>
                            <td class="text-right gradient-right-border-white cell-value2 text-danger" style="vertical-align:middle;">
                                <div class="cell-center" style="margin-left:-1px;margin-right:-2px;">
                                    {{ formatNum(item7.Sales) }}
                                </div>
                            </td>
                            
                            <td class="text-center cell-value2 text-danger" style="vertical-align:middle;">
                                <div class="cell-right">
                                    {{ formatNum(item7.SelisihPersentase) }} %
                                </div>                               
                            </td>
                        </tr>
                    </table>
                    <Loader v-if="loading.table"/>
                </div>
            </div>
        </div>
        
        <div class="row" v-if="false">
            <div class="col-md-12 mb-4">
                <h5 class="text-center">10 SPBU dengan Penurunan Tertinggi ({{ this.monthBefore }} {{ this.currentYear }})</h5>
                <ReportResultTable  :reportname="'LowestSalesUnit'" :reportdata="lowestsalesunitdata" :loading="loading.lowestsales" :reporturl="''" :issuccess="loading.isSuccess" style="width:100%;"/> 	
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Growth By Month ({{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="160" style="margin-top:20px" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 mb-4" v-for="(item,idx) in chartdatabyproductgroup" :key="idx">
                <div class="box-title-border-with-detail px-3 py-1" style="">Growth By Month ({{ currentYear }}) - <b>{{ item.CategoryType }}</b></div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <BarChart v-loading.body="loading.table" :data="item.data" :width="500" :height="260" style="margin-top:20px" />
                </div>
            </div>

            <div class="col-md-6 mb-4" v-show="false">
                <h5 class="text-center">Growth By Year ({{ this.monthBefore }} {{ this.currentYear }})</h5>
                <BarChart v-if="showchartconsole" v-loading.body="loading.table" :data="chartdatabyproduct" :width="500" :height="300"/>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-md-4 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Komposisi Per Kategori (YTD {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <PieChart v-loading.body="loading.table" :data="piechartdata" />
                </div>
            </div>
            <div class="col-md-4 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Komposisi Branch (YTD {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <PieChart v-loading.body="loading.komposisi" :data="piechartkomposisibyareadata" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'
import Loader from '@/components/loader/Loader2.vue'

export default {
    extends:Fuel,
	components: {
        ReportResultTable,
        BarChart,
        LineChart,
        PieChart,
        Loader,
    },
    props: ['tabIndex','tabName', 'tabLabel','showchartconsole'],
    computed:{

	},
    watch:{
        showchartconsole() {
            //console.log('showchartconsole: ' + this.showchartconsole)
        }
    },
    mounted(){
        this.getBusinessStoreTracking()
        /*
        this.getSalesByProductMonthly()
        this.getPaymentMethodSummary()
        this.getRkapRealisasi()
        this.getKomposisiByArea()
        this.getLowestSalesUnit()
        this.getLowestGrowthByMonth()
        this.getLowestGrowthByYear()
        */
    },
    data(){
		return {
            chartcolors: ['#F56C6C','#67C23A','#3C61FF','#F14C5D', '#E6A23C','#8C5CFF'],
            showchart: true,
            loading: {
                table: false,
                achievement: false,
                paymentmethod: false,
                komposisi: false,
                lowestsales: false,

                growthbyyear: false,
                growthbymonth: false,
            },

            chartdata: [],
            chartdatabyproductgroup:[],
            chartdatabyproduct : [],
            paymentmethoddata: {
                data: [
                    {
                        cash_percentage: 0,
                        non_cash_percentage: 0,
                        non_cash_percentage_edc: 0,
                        non_cash_percentage_voucher: 0,
                        non_cash_percentage_rfid: 0,
                    },
                ]
            },
            rkaprealisasi: {
                data: [ 
                    {
                        RealisasiYtd: 0,
                        TargetYtd: 0,
                        Performance: 0,
                        RKAPyear: 0,
                        LeftOverTarget: 0,
                        LeftOverTargetPerc: 0,
                    }
                ],
            },
            komposisibyareadata: [],

            lowestsalesunitdata: [],
            piechartdata:[],
            piechartkomposisibyareadata: [],
            growthbymonth:[],
            growthbyyear:[],

            monthBefore: this.getMonthName(Penanggalan().bulan-1),
            monthBefore2: this.getMonthName(Penanggalan().bulan-2),
            currentYear: Penanggalan().tahun,

            stacked : false,
            plantno: this.$route.query.plant ? this.$route.query.plant : '',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : 'SPBU',
			period: this.$route.query.period ? this.$route.query.period : 'monthly',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : 'product',
			detail3: this.$route.query.detail3 ? this.$route.query.detail3 : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			satgas: this.$route.query.satgas ? this.$route.query.satgas : '',
            date: { 
                Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
                End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().bulanKemarin, 
            },
                                
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : this.getLastDayOfMonth(Penanggalan().tahun, (Penanggalan().bulan-1))], 
                
        }
    },
    methods:{
        async getBusinessStoreTracking(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/bright/businessstoretrackingconsol?'
            //this.urlRequestParams+='/fuel2/payment?'


            //this.urlRequestParams+='&date-range-start='+this.date.Start
            //this.urlRequestParams+='&date-range-end='+this.date.End

            //console.log('daterange: ' + this.dateRange)
            //console.log('this.dateRange[0]: ' + this.dateRange[0])
            //console.log('this.dateRange[1]: ' + this.dateRange[1])

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

            //if(this.monthRange[0] != 'undefined')
            //this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

            //if(this.monthRange[1] != 'undefined')
            //this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

            this.urlRequestParams+='&period='+this.period
            this.urlRequestParams+='&plant='+this.plantno
            this.urlRequestParams+='&station='+this.stationid
            this.urlRequestParams+='&type='+this.stationtype
            this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&owner='+this.owner
            this.urlRequestParams+='&lokasi='+this.lokasi
            this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&satgas='+this.satgas
            this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2 + '_' + this.detail3

            //additiona
            this.urlRequestParams+='&store-tracking=1'

            //this.urlRequestParams+='&city='+this.city
            //this.urlRequestParams+='&presentation='+this.presentation
            //this.urlRequestParams+='&detailView='+this.detail
            //this.urlRequestParams+='&active='+this.active

            this.loading.table = true;
            this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    let responsedata = response.data;
                    this.loading.isSuccess = true;
                    this.reportdata = response.data;

                    this.growthbymonth.data = responsedata.data.growth_lowest_previous_month;
                    this.growthbyyear.data = responsedata.data.growth_lowest_previous_year; 
                    this.groupByProductName(responsedata.data.growth_by_month_all_category)
                    this.setChartProductMonthly()
                    //this.setChartProduct()
                    this.pieChartProduct()
                    this.pieChartKomposisiBBM()

                    this.redrawChartGrowth()

                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.table = false;
                })
        },

        async getPaymentMethodSummary(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/paymentMethodSummary?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&type='+this.stationtype

            this.loading.paymentmethod = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.paymentmethoddata = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.paymentmethod = false;
                })
        },

        async getRkapRealisasi(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/achievementRkapRealisasi?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

            this.loading.achievement = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.rkaprealisasi = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.achievement = false;
                })
        },

        async getKomposisiByArea(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/komposisiVolumeByArea?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&type='+this.stationtype

            this.loading.komposisi = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.komposisibyareadata = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))

                    let prefix = ''
                    let valuecol = 'PerformSales'
                    let legend = 'ProductGroup'
                    let label = 'SalesArea'
                    
                    //this.komposisibyareadata = this.processBarChart(this.komposisibyareadata.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false, this.stacked);	
                    
                    this.pieChartKomposisiBBM()

                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.komposisi = false;
                })
        },

        async getLowestSalesUnit(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/lowestSalesUnit?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

            this.loading.lowestsales = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.lowestsalesunitdata = response.data;
                   
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.lowestsales = false;
                })
        },

        async getLowestGrowthByMonth(){
            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/growthbymonthlowest?'

            this.loading.growthbymonth = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.growthbymonth = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.growthbymonth = false;
                })
        },

        async getLowestGrowthByYear(){
            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/growthbyyearlowest?'

            this.loading.growthbyyear = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.growthbyyear = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.growthbyyear = false;
                })
        },

        setChartProductMonthly(){
            let data = this.reportdata.data.growth_by_month_all_category;
            let prefix = ''
            let valuecol = 'TotalSales'
            let legend = 'CategoryType'
            let label = 'YearMonth'

            this.chartdata = this.processBarChart(data, legend, prefix, valuecol, false, label, "", 1, 2, this.chartcolors, false, false, false, this.stacked);			
        }, 
        setChartByProductMonthly(data, color){
            //let data = this.reportdata
            let prefix = ''
            let valuecol = 'TotalSales'
            let legend = 'CategoryType'
            let label = 'YearMonth'

            return this.processBarChart(data, legend, prefix, valuecol, false, label, "", 1, 2, [`${color}`], false, false, false, this.stacked);			
        },
        setChartProduct(){
            let data = this.reportdata
            let prefix = ''
            let valuecol = 'TotalVolume'
            let legend = 'legend'
            let label = 'ProductName'
            
            this.chartdatabyproduct = this.processBarChart(data.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false, this.stacked);	
            
            //console.log('this.chartdatabyproduct: ' + JSON.stringify(this.chartdatabyproduct))
        },

        pieChartProduct()
        {
            let item = this.reportdata.data.komposisi_per_category
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].CategoryType] = this.chartcolors[idx] //Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].CategoryType, 
                    amount: item[row].TotalSales,
                };

                value.push(main);
                idx++;
            }

            let result = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            //console.log('komposisi per category : ' + JSON.stringify(data))          

            //console.log('groupedArray: ' + JSON.stringify(groupedArray));
            this.piechartdata = result

            return result 
        },

        pieChartKomposisiBBM()
        {
            let item = this.reportdata.data.komposisi_per_branch
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].BranchType] = this.chartcolors[idx] //Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].BranchType, 
                    amount: item[row].TotalSales,
                };

                value.push(main);
                idx++;
            }

            let result = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            //console.log('result: ' + JSON.stringify(result))          

            //console.log('groupedArray: ' + JSON.stringify(groupedArray));
            this.piechartkomposisibyareadata = result

            return result 
        },

        groupByProductName(data) {
            // Use reduce to group elements by the 'CategoryType' property
            const grouped = data.reduce((result, item) => {
                const key = item.CategoryType; // Property to group by
                if (!result[key]) {
                    result[key] = []; // Initialize an array for this group
                }
                result[key].push(item); // Add the item to the group
                return result;
            }, 
            {});
            //console.log('grouped: ' + JSON.stringify(grouped))

            let crdata = []

            let idx = 0;
            for (const key2 in grouped) {
                if (Object.prototype.hasOwnProperty.call(grouped, key2)) {
                //if (grouped.hasOwnProperty(key2)) {
                    //console.log(`Group: ${key2}`);
                    const groupItems = grouped[key2];
                    let chartDataItem = this.setChartByProductMonthly(groupItems, this.chartcolors[idx])
                    let dataItem = {
                        CategoryType: `${key2}`,
                        data: chartDataItem,
                    }
                    crdata.push(dataItem)
                    /*
                    for (const item of groupItems) {
                        console.log(`  - ${item.name}, ID: ${item.id}`);
                    }*/
                    idx++
                }
            }

            this.chartdatabyproductgroup = crdata

            //console.log('crdata: ' + JSON.stringify(crdata))

        },

        redrawChartGrowth() {
            this.showchartconsole = false
            setTimeout(() => {
                this.showchartconsole = true
                //console.log('Redraw chart growth')
            }, 1000);
        },
    }
}
</script>

<style scoped>
.box-border {
    border: 0.13rem solid #409EFF;  /**#0077FF */
    border-radius: 4px;
}

.bg-color {
    background: #FAFBFC;
}

.box-title-border-with-detail {
    background-color: #409EFF ; /**#0077FF */
    color:white;
    display: block; /**inline-block */
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}

.box-border-with-title {
    border: 0.13rem solid #409EFF;  /**#0077FF */
    /*border-top-right-radius: 4px; */
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.box-number {
    background: #409EFF ;
    color:white;
    font-weight: 600;
    font-size: 12px;
    border-radius: 2px;
}

.background-primary {
    background: #409EFF;
    border-radius: 4px;
}

.text-secondary {
    color:#909399;
}

.text-bold {
    font-weight:bold;
}

.cell-value {
    font-size:15px;
    font-weight: 600;
}

.cell-value2 {
    font-size:13px;
    font-weight: 500;
}

.cell-center {
    background:white;
    height:50px;
    border-top:1px solid #E6ECF1;
    border-bottom:1px solid #E6ECF1;
    padding: 13px 10px;
}

.cell-left {
    background:white;
    padding-top:10px;
    padding-left:12px;
    height:50px;
    border-top-left-radius:3px;
    border-bottom-left-radius:3px;
    border-left:1px solid #E6ECF1;
    border-top:1px solid #E6ECF1;
    border-bottom:1px solid #E6ECF1;
}

.cell-right {
    background:white;
    padding:13px 10px;
    height:50px;
    border-top-right-radius:3px;
    border-bottom-right-radius:3px;
    border-right:1px solid #E6ECF1;
    border-top:1px solid #E6ECF1;
    border-bottom:1px solid #E6ECF1;
}

.text-color-primary{
    color:#409EFF;
}

.text-color-success{
    color:#67C23A;
}

.text-color-danger{
    color:#F56C6C;
}

.text-color-warning{
    color:#E6A23C;
}

.cell-padding-1 {
    padding:5px 12px;
}

.td-header{
    font-size:12px;
}

.text-left {
    text-align: left;
    vertical-align: top;
}

.vertical.dark {
  background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.4), rgba(255,255,255,0));
}

.gradient-border2 {
  border: none; /* Remove the default border */
  padding: 10px; /* Add padding for content */
  background: linear-gradient(to right, #FF5733, #FFC300, #FF5733); /* Gradient background */
  background-clip: content-box; /* Clip background to content area */
  border-image: linear-gradient(to right, #FF5733, #FFC300, #FF5733); /* Gradient border image */
  border-image-slice: 1; /* Slice the border image */
  border-width: 5px; /* Border width */
  border-style: solid; /* Border style */
}


.gradient-right-border {
  /*border-right:1px solid #ddd;*/
  position: relative ; /* Make the container relative */
}

.gradient-right-border::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1px; /* Width of the vertical border */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #e1e1e1, rgba(255, 255, 255, 0.0)); 
  /*background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.4), rgba(255,255,255,0));*/
}

.gradient-right-border-white {
  /*border-right:1px solid #ddd;*/
  position: relative ; /* Make the container relative */
}

.gradient-right-border-white::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1px; /* Width of the vertical border */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 1.0), #e7e7e7, rgba(255, 255, 255, 1.0)); 
  /*background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.4), rgba(255,255,255,0));*/
}

</style>
